import React, {useEffect, useState, useRef} from 'react';
import {Divider, Table, Popconfirm, Card, Switch, Input, Button, Tag, Col, Row, Drawer, Tooltip} from 'antd';
import Highlighter from 'react-highlight-words';
import {CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EditOutlined, SearchOutlined} from '@ant-design/icons';
import { ColumnProps } from 'antd/lib/table';
import {AlertMessages} from '@gtpl/shared-utils/alert-messages';
import {Link} from 'react-router-dom';

import {OverTimeCategoryDto} from '@gtpl/shared-models/hrms';
import {OverTimeCategoryService} from '@gtpl/shared-services/hrms';
import {OverTimeCategory} from '@gtpl/pages/hrms/hrms-components/over-time-category';

import './over-time-category-grid.css';

/* eslint-disable-next-line */
export interface OverTimeCategoryGridProps {}

export function OverTimeCategoryGrid(
  props: OverTimeCategoryGridProps
) {

  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState(''); 
  const [searchedColumn, setSearchedColumn] = useState('');

  const [drawerVisible, setDrawerVisible] = useState(false); 
  
  const [overTimeCatData, setOverTimeCatData] = useState<OverTimeCategoryDto[]>([]);
  const [selectedCatData, setSelectedCatData] = useState<any>(undefined);
  const overTimeCatService = new OverTimeCategoryService();

  useEffect(() => {
    getAllOverTimeCategories();
  },[])

  const getAllOverTimeCategories = () => {
    overTimeCatService.getAllOverTimeCategories().then(res => {
      if(res.status){
        setOverTimeCatData(res.data);
      }else {
        if(res.intlCode){
          setOverTimeCatData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        }else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }        
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const deleteOverTimeCategory = (data: OverTimeCategoryDto) => {
    data.isActive = data.isActive? false: true;
    overTimeCatService.activateOrDeactivate(data).then(res => {
      if(res.status){
        getAllOverTimeCategories();
        AlertMessages.getSuccessMessage('Success');
      }else{
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const updateOverTimeCategory = (data: OverTimeCategoryDto) => {
    overTimeCatService.update(data).then(res => {
      if(res.status){
        AlertMessages.getSuccessMessage('Updated Successfully');
        getAllOverTimeCategories();
        setDrawerVisible(false);
      }else{
        if(res.intlCode){
          AlertMessages.getErrorMessage(res.internalMessage);
        }else{
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  /**
   * used for column filter
   * @param dataIndex column data index
   */
   const getColumnSearchProps = (dataIndex:string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select());   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) :text
      )
      : null
     
  });

  /**
 * 
 * @param selectedKeys 
 * @param confirm 
 * @param dataIndex 
 */
function handleSearch(selectedKeys, confirm, dataIndex) {
  confirm();
  setSearchText(selectedKeys[0]);
  setSearchedColumn(dataIndex);
};

function handleReset(clearFilters) {
  clearFilters();
  setSearchText('');
};

  //drawer related
  const closeDrawer=()=>{
    setDrawerVisible(false);
  }

  //TO open the form for updation
  const openFormWithData=(viewData: OverTimeCategoryDto)=>{
    setDrawerVisible(true);
    setSelectedCatData(viewData);
    console.log(selectedCatData)
    console.log('selectedCatData')
  }

  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    
    {
      title: 'Over Time Category',
      dataIndex: 'overTimeCategoryName',
      // responsive: ['lg'],
      sorter: (a, b) => a.overTimeCategoryName.length - b.overTimeCategoryName.length,
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('overTimeCategoryName')
    },
    
   
    {
      title: 'Status',
      dataIndex: 'isActive',
      align:'center',
      render: (isActive, rowData) => (
        <>
          {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
          
        </>
      ),
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'InActive',
          value: false,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => 
      {
        
        return record.isActive === value;
      },
      
    },
    {
      title:`Action`,
      dataIndex: 'action',
      render: (text, rowData) => (
        <span>   
           <Tooltip placement="top" title='Edit'>      
            <EditOutlined  className={'editSamplTypeIcon'}  type="edit" 
              onClick={() => {
                if (rowData.isActive) {
                  openFormWithData(rowData);
                } else {
                  AlertMessages.getErrorMessage('You Cannot Edit Deactivated Over Time Category');
                }
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />
          </Tooltip>
          <Divider type="vertical" />
            <Popconfirm onConfirm={e =>{deleteOverTimeCategory(rowData);}}
            title={
              rowData.isActive
                ? 'Are you sure to Deactivate Over Time Category ?'
                :  'Are you sure to Activate Over Time Category ?'
            }
          >
            <Switch  size="default"
                className={ rowData.isActive ? 'toggle-activated' : 'toggle-deactivated' }
                checkedChildren={<RightSquareOutlined type="check" />}
                unCheckedChildren={<RightSquareOutlined type="close" />}
                checked={rowData.isActive}
              />
            
          </Popconfirm>
        </span>
      )
    }
  ];

  /**
     * 
     * @param pagination 
     * @param filters 
     * @param sorter 
     * @param extra 
     */
   const onChange=(pagination, filters, sorter, extra)=> {
    console.log('params', pagination, filters, sorter, extra);
  }
  const OpenFormTocreateRecord = () => {
   console.log('redirect here');
   
  }

  return (
    <Card title={<span style={{color: 'white'}}>Over Time Categories</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={<Link to='/over-time-categories-form' ><Button className='panel_button' >Create </Button></Link>}
    >
      <br></br>
     <Row gutter={40}>
      <Col>
          <Card title={'Total Over Time Categories: ' + overTimeCatData.length} style={{textAlign: 'left', width: 290, height: 41,backgroundColor:'#bfbfbf'}}></Card>
          </Col>
          <Col>
           <Card title={'Active: ' + overTimeCatData.filter(el => el.isActive).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#52c41a'}}></Card>
          </Col>
          <Col>
           <Card title={'In-Active :' + overTimeCatData.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#f5222d'}}></Card>
          </Col>
          </Row>
          <br></br>
          <Table
          rowKey={record => record.overTimeCategoryId}
          columns={columnsSkelton}
          dataSource={overTimeCatData}
          scroll = {{x:true}}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          onChange={onChange}
          bordered />
        <Drawer bodyStyle={{ paddingBottom: 80 }} title='Update' width={window.innerWidth > 768 ? '50%' : '85%'}
            onClose={closeDrawer} visible={drawerVisible} closable={true}>
            <Card headStyle={{ textAlign: 'center', fontWeight: 500, fontSize: 16 }} size='small'>
              <OverTimeCategory key={Date.now()}
                update={updateOverTimeCategory}
                isUpdate={true}
                data={selectedCatData}
                closeForm={closeDrawer} 
                />
            </Card>
          </Drawer>
    </Card>
  );
}

export default OverTimeCategoryGrid;
